var $2iT2y$webstreamspolyfill = require("web-streams-polyfill");
var $2iT2y$miniprogramfile = require("miniprogram-file");
var $2iT2y$miniprogramtextencoder = require("miniprogram-text-encoder");
var $2iT2y$miniprogramtextdecoder = require("miniprogram-text-decoder");
var $2iT2y$tarojstaro = require("@tarojs/taro");


function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $6c3dd9fe9db2ac78$exports = {};

$parcel$export($6c3dd9fe9db2ac78$exports, "Headers", function () { return $6c3dd9fe9db2ac78$export$79b704688b15c0f4; });
const $6c3dd9fe9db2ac78$var$store = new WeakMap();
class $6c3dd9fe9db2ac78$export$79b704688b15c0f4 {
    constructor(init){
        if (!init) return;
        init = init instanceof $6c3dd9fe9db2ac78$export$79b704688b15c0f4 ? [
            ...init
        ] : init instanceof Array ? init : Object.entries(init);
        for (const [key, value] of init)this.append(key, value);
    }
    append(name, value) {
        const map = $6c3dd9fe9db2ac78$var$store.get(this) || {};
        (map[name] ||= []).push(value);
        $6c3dd9fe9db2ac78$var$store.set(this, map);
    }
    set(name, value) {
        const map = $6c3dd9fe9db2ac78$var$store.get(this) || {};
        map[name] = [
            value
        ];
        $6c3dd9fe9db2ac78$var$store.set(this, map);
    }
    get(name) {
        return $6c3dd9fe9db2ac78$var$store.get(this)?.[name]?.join() ?? null;
    }
    has(name) {
        return this.get(name) != null;
    }
    delete(name) {
        const map = $6c3dd9fe9db2ac78$var$store.get(this) || {};
        delete map[name];
    }
    *[Symbol.iterator]() {
        for (const [key, value] of Object.entries($6c3dd9fe9db2ac78$var$store.get(this) || {}))yield [
            key,
            value?.join()
        ];
    }
    entries() {
        return this[Symbol.iterator]();
    }
    *keys() {
        yield* Object.keys($6c3dd9fe9db2ac78$var$store.get(this) || {});
    }
    *values() {
        for (const value of Object.values($6c3dd9fe9db2ac78$var$store.get(this) || {}))yield value?.join();
    }
    forEach(callbackfn, thisArg) {
        for (const [key, value] of this)callbackfn.call(thisArg, value, key, this);
    }
    getSetCookie() {
        return $6c3dd9fe9db2ac78$var$store.get(this)?.['Set-Cookie'] ?? [];
    }
}


var $cd2991f7aee6102f$exports = {};

$parcel$export($cd2991f7aee6102f$exports, "Body", function () { return $cd2991f7aee6102f$export$4b2c32e08f77ff18; });
$parcel$export($cd2991f7aee6102f$exports, "FormData", function () { return $5a13781474bbde5a$export$2e2bcd8739ae039; });
$parcel$export($cd2991f7aee6102f$exports, "ReadableStream", function () { return $2iT2y$webstreamspolyfill.ReadableStream; });
$parcel$export($cd2991f7aee6102f$exports, "TransformStream", function () { return $2iT2y$webstreamspolyfill.TransformStream; });
$parcel$export($cd2991f7aee6102f$exports, "WritableStream", function () { return $2iT2y$webstreamspolyfill.WritableStream; });


let $5a13781474bbde5a$var$FormDataPolyfill;
if ("undefined" == typeof FormData) {
    const t = (0, ($parcel$interopDefault($2iT2y$miniprogramfile))), e = {
        blob: (t)=>"[object Blob]" === Object.prototype.toString.call(t),
        file: (t)=>"[object File]" === Object.prototype.toString.call(t),
        obj: (t)=>null !== t && "object" == typeof t
    }, o = function(t, e) {
        if (t.length < e) throw new TypeError(`${e} argument required, but only ${t.length} present.`);
    }, r = function(o, r, l) {
        return e.blob(r) ? r = new t([
            r
        ], l = l || "blob") : e.file(r) && (l = l || r.name), [
            o,
            r
        ];
    }, l = new WeakMap;
    class i {
        constructor(t){
            if (void 0 !== t) throw new Error("Failed to construct 'FormData': the 'form' option is unsupported.");
            l.set(this, []);
        }
        append(t, e, i) {
            o(arguments, 2), l.get(this).push(r(t, e, i));
        }
        set(t, e, i) {
            o(arguments, 2);
            const n = [], s = r(t, e, i);
            let a = !0;
            l.get(this).forEach((e)=>{
                e[0] === t ? a && (a = !n.push(s)) : n.push(e);
            }), a && n.push(s), l.set(this, n);
        }
        delete(t) {
            o(arguments, 1), t = String(t), l.set(this, l.get(this).filter((e)=>e[0] !== t));
        }
        get(t) {
            o(arguments, 1);
            const e = l.get(this);
            t = String(t);
            for(let o = 0; o < e.length; o++)if (e[o][0] === t) return e[o][1];
            return null;
        }
        getAll(t) {
            return o(arguments, 1), t = String(t), l.get(this).reduce((e, o)=>(o[0] === t && e.push(o[1]), e), []);
        }
        has(t) {
            o(arguments, 1), t = String(t);
            for(let e = 0; e < l.get(this).length; e++)if (l.get(this)[e][0] === t) return !0;
            return !1;
        }
        *entries() {
            for(let t = 0; t < l.get(this).length; t++)yield l.get(this)[t];
        }
        [Symbol.iterator]() {
            return this.entries();
        }
        forEach(t, e) {
            o(arguments, 1);
            for (const [o, r] of this)t.call(e, r, o, this);
        }
        *keys() {
            for (const [t] of this)yield t;
        }
        *values() {
            for (const [, t] of this)yield t;
        }
        toString() {
            return "[object FormData]";
        }
    }
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(i.prototype, Symbol.toStringTag, {
        value: "FormData"
    }), $5a13781474bbde5a$var$FormDataPolyfill = i;
} else $5a13781474bbde5a$var$FormDataPolyfill = FormData;
var $5a13781474bbde5a$export$2e2bcd8739ae039 = $5a13781474bbde5a$var$FormDataPolyfill;


var $94656382dd750fb1$exports = {};

$parcel$export($94656382dd750fb1$exports, "Blob", function () { return $94656382dd750fb1$export$3b660928c86ff55c; });


let $d1204ba78e255ac5$var$BlobPolyfill;
if ("undefined" == typeof Blob) {
    const e = function(e) {
        return e && Object.prototype.isPrototypeOf.call(DataView.prototype, e);
    }, t = function(e) {
        const t = new Array(e.byteLength), r = new Uint8Array(e);
        let o = t.length;
        for(; o--;)t[o] = r[o];
        return t;
    }, r = [
        "[object Int8Array]",
        "[object Uint8Array]",
        "[object Uint8ClampedArray]",
        "[object Int16Array]",
        "[object Uint16Array]",
        "[object Int32Array]",
        "[object Uint32Array]",
        "[object Float32Array]",
        "[object Float64Array]"
    ], o = function(e) {
        return e && r.indexOf(Object.prototype.toString.call(e)) > -1;
    }, n = function(e) {
        let t = 0, r = e.length;
        for(; r--;)t += e[r].length;
        const o = new Uint8Array(t);
        let n = 0;
        const i = e.length;
        for(r = 0; r < i; r++){
            const t = e[r];
            o.set(t, n), n += t.byteLength || t.length;
        }
        return o;
    }, i = (0, ($parcel$interopDefault($2iT2y$miniprogramtextencoder))).prototype.encode.bind(new (0, ($parcel$interopDefault($2iT2y$miniprogramtextencoder)))), l = (0, ($parcel$interopDefault($2iT2y$miniprogramtextdecoder))).prototype.decode.bind(new (0, ($parcel$interopDefault($2iT2y$miniprogramtextdecoder)))), a = function(e) {
        return e.arrayBuffer && e._buffer instanceof Uint8Array;
    };
    class f {
        constructor(r = [], l){
            if ((l = l || {}).endings = l.endings || "transparent", l.type = l.type || "", "transparent" !== l.endings) throw new TypeError(`Failed to construct 'Blob': Failed to read the 'endings' property from 'BlobPropertyBag': The provided value '${l.endings}' is not a valid enum value of type EndingType.`);
            const f = new Array(r.length);
            for(let n = 0, l = r.length; n < l; n++){
                const l = r[n];
                a(l) ? f[n] = l._buffer : "string" == typeof l ? f[n] = i(l) : Object.prototype.isPrototypeOf.call(ArrayBuffer.prototype, l) || o(l) ? f[n] = t(l) : e(l) ? f[n] = t(l.buffer) : f[n] = i(String(l));
            }
            this._buffer = n(f), this.size = this._buffer.length, this.type = l.type, /[^\u0020-\u007E]/.test(this.type) ? this.type = "" : this.type = this.type.toLowerCase();
        }
        slice(e, t, r) {
            const o = this._buffer.slice(e || 0, t || this._buffer.length);
            return new f([
                o
            ], {
                type: r
            });
        }
        toString() {
            return "[object Blob]";
        }
        arrayBuffer() {
            return new Promise((e, t)=>{
                try {
                    e((this._buffer.buffer || this._buffer).slice(0));
                } catch (e) {
                    t(new Error("Failed to read the blob/file"));
                }
            });
        }
        text() {
            return new Promise((e, t)=>{
                try {
                    e(l(this._buffer));
                } catch (e) {
                    t(new Error("Failed to read the blob/file"));
                }
            });
        }
        stream() {
            throw new Error("Include https://github.com/MattiasBuelens/web-streams-polyfill");
        }
    }
    let c;
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(f.prototype, Symbol.toStringTag, {
        value: "Blob"
    });
    try {
        new ReadableStream({}), c = function() {
            let e = 0;
            const t = this;
            return new ReadableStream({
                pull: function(r) {
                    return t.slice(e, e + 524288).arrayBuffer().then(function(o) {
                        e += o.byteLength;
                        const n = new Uint8Array(o);
                        r.enqueue(n), e == t.size && r.close();
                    });
                }
            });
        };
    } catch (e) {}
    c && (f.prototype.stream = c), $d1204ba78e255ac5$var$BlobPolyfill = f;
} else $d1204ba78e255ac5$var$BlobPolyfill = Blob;
var $d1204ba78e255ac5$export$2e2bcd8739ae039 = $d1204ba78e255ac5$var$BlobPolyfill;



class $94656382dd750fb1$export$3b660928c86ff55c extends (0, $d1204ba78e255ac5$export$2e2bcd8739ae039) {
    async bytes() {
        const buffer = await this.arrayBuffer();
        return new Uint8Array(buffer);
    }
    slice(start, end, contentType) {
        const blob = super.slice(start, end, contentType);
        return Object.setPrototypeOf(blob, $94656382dd750fb1$export$3b660928c86ff55c.prototype);
    }
    stream() {
        return new (0, $2iT2y$webstreamspolyfill.ReadableStream)({
            start: async (controller)=>{
                const bytes = await this.bytes();
                for(let offset = 0; offset < bytes.length; offset += 1024){
                    const chunk = bytes.slice(offset, offset + 1024);
                    controller.enqueue(chunk);
                }
                controller.close();
            }
        });
    }
}


class $cd2991f7aee6102f$export$4b2c32e08f77ff18 {
    async bytes() {
        const chunks = [], reader = this.body?.getReader();
        if (reader) while(true){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            chunks.push(...value);
        }
        return new Uint8Array(chunks);
    }
    async arrayBuffer() {
        return (await this.bytes()).buffer;
    }
    async blob() {
        return new (0, $94656382dd750fb1$export$3b660928c86ff55c)([
            await this.arrayBuffer()
        ]);
    }
    async text() {
        const data = await this.blob();
        return data.text();
    }
    async json() {
        const text = await this.text();
        return JSON.parse(text);
    }
    /**
     * @deprecated 尚未实现内部逻辑
     */ async formData() {
        return new (0, $5a13781474bbde5a$export$2e2bcd8739ae039)();
    }
    constructor(){
        this.body = null;
        this.bodyUsed = false;
    }
}


var $3477d7d8895a59b9$exports = {};

$parcel$export($3477d7d8895a59b9$exports, "Request", function () { return $3477d7d8895a59b9$export$7fa6c5b6f8193917; });


var $e93ae1c9e041d239$exports = {};

$parcel$export($e93ae1c9e041d239$exports, "Response", function () { return $e93ae1c9e041d239$export$9f633d56d7ec90d3; });
$parcel$export($e93ae1c9e041d239$exports, "URLSearchParams", function () { return $6fb7bd46cb7d5f65$export$2e2bcd8739ae039; });
// @ts-expect-error Upstream export bug
/*! (c) Andrea Giammarchi - ISC */ var $6fb7bd46cb7d5f65$var$self = {};
try {
    (function(URLSearchParams1, plus) {
        if (new URLSearchParams1('q=%2B').get('q') !== plus || new URLSearchParams1({
            q: plus
        }).get('q') !== plus || new URLSearchParams1([
            [
                'q',
                plus
            ]
        ]).get('q') !== plus || new URLSearchParams1('q=\n').toString() !== 'q=%0A' || new URLSearchParams1({
            q: ' &'
        }).toString() !== 'q=+%26' || new URLSearchParams1({
            q: '%zx'
        }).toString() !== 'q=%25zx') throw URLSearchParams1;
        $6fb7bd46cb7d5f65$var$self.URLSearchParams = URLSearchParams1;
    })(URLSearchParams, '+');
} catch (URLSearchParams1) {
    (function(Object1, String1, isArray) {
        'use strict';
        var create = Object1.create;
        var defineProperty = Object1.defineProperty;
        var find = /[!'\(\)~]|%20|%00/g;
        var findPercentSign = /%(?![0-9a-fA-F]{2})/g;
        var plus = /\+/g;
        var replace = {
            '!': '%21',
            "'": '%27',
            '(': '%28',
            ')': '%29',
            '~': '%7E',
            '%20': '+',
            '%00': '\x00'
        };
        var proto = {
            append: function(key, value) {
                appendTo(this._ungap, key, value);
            },
            delete: function(key) {
                delete this._ungap[key];
            },
            get: function(key) {
                return this.has(key) ? this._ungap[key][0] : null;
            },
            getAll: function(key) {
                return this.has(key) ? this._ungap[key].slice(0) : [];
            },
            has: function(key) {
                return key in this._ungap;
            },
            set: function(key, value) {
                this._ungap[key] = [
                    String1(value)
                ];
            },
            forEach: function(callback, thisArg) {
                var self = this;
                for(var key in self._ungap)self._ungap[key].forEach(invoke, key);
                function invoke(value) {
                    callback.call(thisArg, value, String1(key), self);
                }
            },
            toJSON: function() {
                return {};
            },
            toString: function() {
                var query = [];
                for(var key in this._ungap){
                    var encoded = encode(key);
                    for(var i = 0, value = this._ungap[key]; i < value.length; i++)query.push(encoded + '=' + encode(value[i]));
                }
                return query.join('&');
            }
        };
        for(var key in proto)defineProperty(URLSearchParams1.prototype, key, {
            configurable: true,
            writable: true,
            value: proto[key]
        });
        $6fb7bd46cb7d5f65$var$self.URLSearchParams = URLSearchParams1;
        function URLSearchParams1(query) {
            var dict = create(null);
            defineProperty(this, '_ungap', {
                value: dict
            });
            switch(true){
                case !query:
                    break;
                case typeof query === 'string':
                    if (query.charAt(0) === '?') query = query.slice(1);
                    for(var pairs = query.split('&'), i = 0, length = pairs.length; i < length; i++){
                        var value = pairs[i];
                        var index = value.indexOf('=');
                        if (-1 < index) appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));
                        else if (value.length) appendTo(dict, decode(value), '');
                    }
                    break;
                case isArray(query):
                    for(var i = 0, length = query.length; i < length; i++){
                        var value = query[i];
                        appendTo(dict, value[0], value[1]);
                    }
                    break;
                case 'forEach' in query:
                    query.forEach(addEach, dict);
                    break;
                default:
                    for(var key in query)appendTo(dict, key, query[key]);
            }
        }
        function addEach(value, key) {
            appendTo(this, key, value);
        }
        function appendTo(dict, key, value) {
            var res = isArray(value) ? value.join(',') : value;
            if (key in dict) dict[key].push(res);
            else dict[key] = [
                res
            ];
        }
        function decode(str) {
            return decodeURIComponent(str.replace(findPercentSign, '%25').replace(plus, ' '));
        }
        function encode(str) {
            return encodeURIComponent(str).replace(find, replacer);
        }
        function replacer(match) {
            return replace[match];
        }
    })(Object, String, Array.isArray);
}
(function(URLSearchParamsProto) {
    var iterable = false;
    try {
        iterable = !!Symbol.iterator;
    } catch (o_O) {}
    /* istanbul ignore else */ if (!('forEach' in URLSearchParamsProto)) URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
        var self = this;
        var names = Object.create(null);
        this.toString().replace(/=[\s\S]*?(?:&|$)/g, '=').split('=').forEach(function(name) {
            if (!name.length || name in names) return;
            (names[name] = self.getAll(name)).forEach(function(value) {
                callback.call(thisArg, value, name, self);
            });
        });
    };
    /* istanbul ignore else */ if (!('keys' in URLSearchParamsProto)) URLSearchParamsProto.keys = function keys() {
        return iterator(this, function(value, key) {
            this.push(key);
        });
    };
    /* istanbul ignore else */ if (!('values' in URLSearchParamsProto)) URLSearchParamsProto.values = function values() {
        return iterator(this, function(value, key) {
            this.push(value);
        });
    };
    /* istanbul ignore else */ if (!('entries' in URLSearchParamsProto)) URLSearchParamsProto.entries = function entries() {
        return iterator(this, function(value, key) {
            this.push([
                key,
                value
            ]);
        });
    };
    /* istanbul ignore else */ if (iterable && !(Symbol.iterator in URLSearchParamsProto)) URLSearchParamsProto[Symbol.iterator] = URLSearchParamsProto.entries;
    /* istanbul ignore else */ if (!('sort' in URLSearchParamsProto)) URLSearchParamsProto.sort = function sort() {
        var entries = this.entries(), entry = entries.next(), done = entry.done, keys = [], values = Object.create(null), i, key, value;
        while(!done){
            value = entry.value;
            key = value[0];
            keys.push(key);
            if (!(key in values)) values[key] = [];
            values[key].push(value[1]);
            entry = entries.next();
            done = entry.done;
        }
        // not the champion in efficiency
        // but these two bits just do the job
        keys.sort();
        for(i = 0; i < keys.length; i++)this.delete(keys[i]);
        for(i = 0; i < keys.length; i++){
            key = keys[i];
            this.append(key, values[key].shift());
        }
    };
    function iterator(self, callback) {
        var items = [];
        self.forEach(callback, items);
        /* istanbul ignore next */ return iterable ? items[Symbol.iterator]() : {
            next: function() {
                var value = items.shift();
                return {
                    done: value === void 0,
                    value: value
                };
            }
        };
    }
    /* istanbul ignore next */ (function(Object1) {
        var dP = Object1.defineProperty, gOPD = Object1.getOwnPropertyDescriptor, createSearchParamsPollute = function(search) {
            function append(name, value) {
                URLSearchParamsProto.append.call(this, name, value);
                name = this.toString();
                search.set.call(this._usp, name ? '?' + name : '');
            }
            function del(name) {
                URLSearchParamsProto.delete.call(this, name);
                name = this.toString();
                search.set.call(this._usp, name ? '?' + name : '');
            }
            function set(name, value) {
                URLSearchParamsProto.set.call(this, name, value);
                name = this.toString();
                search.set.call(this._usp, name ? '?' + name : '');
            }
            return function(sp, value) {
                sp.append = append;
                sp.delete = del;
                sp.set = set;
                return dP(sp, '_usp', {
                    configurable: true,
                    writable: true,
                    value: value
                });
            };
        }, createSearchParamsCreate = function(polluteSearchParams) {
            return function(obj, sp) {
                dP(obj, '_searchParams', {
                    configurable: true,
                    writable: true,
                    value: polluteSearchParams(sp, obj)
                });
                return sp;
            };
        }, updateSearchParams = function(sp) {
            var append = sp.append;
            sp.append = URLSearchParamsProto.append;
            URLSearchParams.call(sp, sp._usp.search.slice(1));
            sp.append = append;
        }, verifySearchParams = function(obj, Class) {
            if (!(obj instanceof Class)) throw new TypeError("'searchParams' accessed on an object that does not implement interface " + Class.name);
        }, upgradeClass = function(Class) {
            var ClassProto = Class.prototype, searchParams = gOPD(ClassProto, 'searchParams'), href = gOPD(ClassProto, 'href'), search = gOPD(ClassProto, 'search'), createSearchParams;
            if (!searchParams && search && search.set) {
                createSearchParams = createSearchParamsCreate(createSearchParamsPollute(search));
                Object1.defineProperties(ClassProto, {
                    href: {
                        get: function() {
                            return href.get.call(this);
                        },
                        set: function(value) {
                            var sp = this._searchParams;
                            href.set.call(this, value);
                            if (sp) updateSearchParams(sp);
                        }
                    },
                    search: {
                        get: function() {
                            return search.get.call(this);
                        },
                        set: function(value) {
                            var sp = this._searchParams;
                            search.set.call(this, value);
                            if (sp) updateSearchParams(sp);
                        }
                    },
                    searchParams: {
                        get: function() {
                            verifySearchParams(this, Class);
                            return this._searchParams || createSearchParams(this, new URLSearchParams(this.search.slice(1)));
                        },
                        set: function(sp) {
                            verifySearchParams(this, Class);
                            createSearchParams(this, sp);
                        }
                    }
                });
            }
        };
        try {
            upgradeClass(HTMLAnchorElement);
            if (/^function|object$/.test(typeof URL) && URL.prototype) upgradeClass(URL);
        } catch (meh) {}
    })(Object);
})($6fb7bd46cb7d5f65$var$self.URLSearchParams.prototype, Object);
var $6fb7bd46cb7d5f65$export$2e2bcd8739ae039 = $6fb7bd46cb7d5f65$var$self.URLSearchParams;







class $e93ae1c9e041d239$export$9f633d56d7ec90d3 extends (0, $cd2991f7aee6102f$export$4b2c32e08f77ff18) {
    constructor(body, init){
        super(), this.type = 'basic', this.ok = false, this.redirected = false;
        this.status = init?.status || 0;
        this.statusText = init?.statusText || '';
        if (init?.headers) this.headers = new (0, $6c3dd9fe9db2ac78$export$79b704688b15c0f4)(init.headers);
        this.body = body instanceof (0, $2iT2y$webstreamspolyfill.ReadableStream) ? body : body instanceof (0, $5a13781474bbde5a$export$2e2bcd8739ae039) ? null : body != null ? new (0, $94656382dd750fb1$export$3b660928c86ff55c)([
            body instanceof (0, $6fb7bd46cb7d5f65$export$2e2bcd8739ae039) ? body + '' : body
        ]).stream() : null;
    }
    clone() {
        return Object.assign(new $e93ae1c9e041d239$export$9f633d56d7ec90d3(), this);
    }
}


class $3477d7d8895a59b9$export$7fa6c5b6f8193917 extends (0, $cd2991f7aee6102f$export$4b2c32e08f77ff18) {
    constructor(input, init){
        super();
        if (input instanceof $3477d7d8895a59b9$export$7fa6c5b6f8193917) Object.assign(this, input);
        else this.url = input + '';
        if (!init) return;
        const { headers: headers, body: body, ...fields } = init;
        if (headers) this.headers = new (0, $6c3dd9fe9db2ac78$export$79b704688b15c0f4)(headers);
        if (body) this.body = new (0, $e93ae1c9e041d239$export$9f633d56d7ec90d3)(body).body;
        Object.assign(this, fields);
    }
    clone() {
        return new $3477d7d8895a59b9$export$7fa6c5b6f8193917(this);
    }
}



var $f5c4a62c33aa0e45$exports = {};

$parcel$export($f5c4a62c33aa0e45$exports, "fetch", function () { return $f5c4a62c33aa0e45$export$e7aa7bc5c1b3cfb3; });



async function $f5c4a62c33aa0e45$export$e7aa7bc5c1b3cfb3(input, init) {
    const req = new (0, $3477d7d8895a59b9$export$7fa6c5b6f8193917)(input, init);
    const { method: method, url: url, headers: headers, mode: mode, credentials: credentials } = req;
    const header = {
        ...Object.fromEntries([
            ...headers
        ]),
        'Content-Type': [
            'HEAD',
            'GET'
        ].includes(method.toUpperCase()) ? 'text/plain' : headers.get('Content-Type')
    };
    const response = await (0, $2iT2y$tarojstaro.request)({
        method: // @ts-ignore
        method,
        url: url,
        header: header,
        mode: // @ts-ignore
        mode,
        credentials: credentials,
        data: await req.arrayBuffer(),
        responseType: 'arraybuffer'
    });
    return new (0, $e93ae1c9e041d239$export$9f633d56d7ec90d3)(response.data, {
        status: response.statusCode,
        statusText: response.errMsg,
        headers: response.header
    });
}



for (const [key, value] of Object.entries({
    Headers: $6c3dd9fe9db2ac78$export$79b704688b15c0f4,
    Body: $cd2991f7aee6102f$export$4b2c32e08f77ff18,
    Request: $3477d7d8895a59b9$export$7fa6c5b6f8193917,
    Response: $e93ae1c9e041d239$export$9f633d56d7ec90d3,
    fetch: $f5c4a62c33aa0e45$export$e7aa7bc5c1b3cfb3
}))globalThis[key] = value;
$parcel$exportWildcard(module.exports, $6c3dd9fe9db2ac78$exports);
$parcel$exportWildcard(module.exports, $cd2991f7aee6102f$exports);
$parcel$exportWildcard(module.exports, $3477d7d8895a59b9$exports);
$parcel$exportWildcard(module.exports, $e93ae1c9e041d239$exports);
$parcel$exportWildcard(module.exports, $f5c4a62c33aa0e45$exports);
$parcel$exportWildcard(module.exports, $94656382dd750fb1$exports);


//# sourceMappingURL=index.js.map
